module.exports = __webpack_public_path__ + "static/media/banner2-mobile2-2024.65a8998f.jpg";